function cn(...classNames: Array<string | undefined | false>) {
  return classNames
    .reduce((classNames: Array<string | undefined | false>, className) => classNames.concat(className), [])
    .join(' ');
}

export default cn;
